import { COLORS } from '@btime/constants'
import React from 'react'

import { countReplies } from '../../../utils/helpers/repliesCounter'
import FlexGrid from '../../../components/structure/FlexGrid'
import Tag from '../../../components/presentation/Tag'

const DynamicListCounters = ({ replies }) => {
  const { actionPlansCount, nonCompliancesCount } = React.useMemo(() => countReplies(replies), [replies])

  return (
    <FlexGrid gutter={0.1}>
      <Tag label={nonCompliancesCount} bgColor={COLORS.red} medium fixedSize />
      <Tag label={actionPlansCount} medium fixedSize />
    </FlexGrid>
  )
}

export default DynamicListCounters
